import { gql } from "@apollo/client";
import { StoryCardFieldsFragment } from "@govlaunch/story";

export default gql`
  query SearchStories($title: String, $tags: [String!], $state: String, $country: String, $cursor: Cursor) {
    searchStories(title: $title, tags: $tags, state: $state, country: $country, cursor: $cursor) {
      items {
        ...StoryCardFields
      }
      pageInfo {
        hasNextPage
        endCursor
      }
    }
  }

  ${StoryCardFieldsFragment}
`;
